import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { NumericFormat } from 'react-number-format';
import { useCookies } from 'react-cookie';
import axios from "axios";
import Notifications, { notify } from "react-notify-toast";

const NacimientoView = ({ show, handleClose, data, edit, callback }) => {

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [loading, setLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);

    const [idMovimiento, setIdMovimiento] = useState(data != undefined ? data.id_movimiento : undefined);
    const [idNacimiento, setIdNacimiento] = useState(data != undefined ? data.id_nacimiento : undefined);
    const [observacion, setObservacion] = useState(data != undefined ? data.observacion : undefined);
    const [fechaNacimiento, setFechaNacimiento] = useState(data != undefined ? data.fecha_nacimiento : undefined);
    const [fechaMovimiento, setFechaMovimiento] = useState(data != undefined ? data.fecha_movimiento : undefined);
    const [potrero, setPotrero] = useState(data != undefined ? data.potrero : undefined);
    const [retiro, setRetiro] = useState(data != undefined ? data.retiro.nombre : undefined);
    const [cantidad, setCantidad] = useState(data != undefined ? data.cantidad : undefined);
    const [carimbo, setCarimbo] = useState(data != undefined ? data.carimbo : undefined);
    const [pesoTotal, setPesoTotal] = useState(data != undefined ? data.peso_total : undefined);    
    const [categoria, setCategoria] = useState(data != undefined ? data.categoria.id_categoria : 0);
    const [owner, setOwner] = useState(data != undefined ? data.owner : undefined);
    const [owners, setOwners] = useState([]);
    const [categories, setCategories] = useState([]);


    const [creationDate, setCreation] = useState(data != undefined ? data.fecha_creacion : undefined);
    const [userCreation, setUserCreation] = useState(data != undefined ? data.usuario_creacion.email : undefined);
    const [userLastModification, setUserLastModification] = useState(data != undefined ? data.usuario_ultima_modificacion.email : undefined);

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const retrieveCategories = () => {
        axios.get(process.env.REACT_APP_API_URL + "category", prepareHeaders())
        .then(rs => {
            console.log(rs);
            if(rs.status == 200){
                let {data} = rs.data;
                setCategories(data);
            }
            else {
                setCategories([]);
            }            
        })
        .catch(error => {
            console.error(error);
            setCategories([]);
        });
    }     

    useEffect(() => {
        console.log(data);
        setIdMovimiento(data != undefined ? data.id_movimiento : undefined);
        setIdNacimiento(data != undefined ? data.id_nacimiento : undefined);
        
        setPesoTotal(data != undefined ? data.peso_total : undefined);
        setObservacion(data != undefined ? data.observacion : undefined);
        setFechaNacimiento(data != undefined ? data.fecha_nacimiento : undefined);
        setFechaMovimiento(data != undefined ? data.fecha_movimiento : undefined);
        setPotrero(data != undefined ? data.potrero : undefined);
        setRetiro(data != undefined ? data.retiro.nombre : undefined);
        setCantidad(data != undefined ? data.cantidad : undefined);

        setCarimbo(data != undefined ? data.carimbo : undefined);
        setCategoria(data != undefined ? data.categoria.id_categoria : 0);

        setCreation(data != undefined ? data.fecha_creacion : undefined);
        setUserCreation(data != undefined ? data.usuario_creacion.email : undefined);
        setUserLastModification(data != undefined ? data.usuario_ultima_modificacion.email : undefined);
        setOwner(data != undefined ? data.owner : undefined);        

    }, [data]);

    const handleUpdate = (e) => {
        var currentFarm = cookie.kUserSession.data["farm"];
        var data = {
            data: {
                birth_date: fechaNacimiento,
                cantidad: parseInt(cantidad),
                carimbo: parseInt(carimbo),
                fecha_movimiento: fechaMovimiento,
                id_categoria: parseInt(categoria),
                id_estancia: parseInt(currentFarm.id),
                id_movimiento: parseInt(idMovimiento),
                id_nacimiento: parseInt(idNacimiento),
                peso_total: parseFloat(pesoTotal),
                observacion: observacion,
                potrero: potrero,
                retiro: retiro,
                owner: owner ? owner.id : undefined
            }
        }
        update(data);        
    }

    const update = (data) => {
        setUpdateLoading(true);
        axios.put(process.env.REACT_APP_API_URL + "movements/entrance/birth", data, prepareHeaders())
        .then(rs => {
            console.log(rs);
            if(rs.status == 200){
                let {data} = rs;
                notify.show("Se ha actualizado la información exitosamente", "success");
                setUpdateLoading(false);
                handleClose();
                callback();
            }
            else {
                setUpdateLoading(false);
                notify.show("Ha ocurrido un error al actualizar la información", "error");
                handleClose();
                callback();
            }
        })
        .catch(error => {
            console.error(error);
            setUpdateLoading(false);
            notify.show("Ha ocurrido un error al actualizar la información", "error");
            handleClose();
            callback();
        })        
    }

    const retrieveOwners = () => {
        let company = cookie.kUserSession.data["company"];
        axios.get(process.env.REACT_APP_API_URL + "owners?company_id=" + company.id , prepareHeaders())
        .then(rs => {
            if(rs.status == 200){
                let data = rs.data;
                setOwners(data);
                setOwner(data[0]);
            }
            else {
                setOwners([]);
                setOwner(undefined);
            }
        })
        .catch(error => {
            console.error(error);
            setOwners([]);
            setOwner(undefined);
        });
    }        

    useEffect(() => {
        retrieveCategories();
        retrieveOwners();
    }, []);    

    return (
        <>
            <Notifications />
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title><b>Datos del nacimiento</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Form>
                        <Row>
                            <Col>
                                <Form.Group controlId="fecha_gasto">
                                    <Form.Label className="karanda-label">Fecha de nacimiento</Form.Label>
                                    <Form.Control disabled={!edit} value={fechaNacimiento} onChange={(e) => { setFechaNacimiento(e.target.value); }} type="date" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="categoria">
                                    <Form.Label className="karanda-label">Zona</Form.Label>
                                    <Form.Control disabled={!edit} value={retiro} onChange={(e) => { setRetiro(e.target.value); }} type="text" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="nro_cota">
                                    <Form.Label className="karanda-label">Potrero</Form.Label>
                                    <Form.Control disabled={!edit} value={potrero} onChange={(e) => { setPotrero(e.target.value); }} type="text" placeholder="Ingrese el potrero" />
                                </Form.Group>
                            </Col>                        
                            <Col>
                                <Form.Group controlId="owner">
                                    <Form.Label className="karanda-label">Propietario</Form.Label>
                                    <Form.Control disabled={!edit}  as="select" value={ owner != undefined ? owner.id : undefined} onChange={(e) => {setOwner({...owner, id: e.target.value});}}>
                                        <option value={0} selected disabled>Seleccione el propietario</option>
                                        {
                                            owners.map((i) => (
                                                <option value={i.id}>{i.nombres + " " + i.apellidos}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>                               
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="categoria">
                                    <Form.Label className="karanda-label">Categoría</Form.Label>
                                    <Form.Control disabled={!edit} value={categoria} onChange={(e) => { setCategoria(e.target.value); }} as="select">
                                        <option value={0}>Seleccione</option>
                                        {
                                            categories.map((i) => (
                                                <option value={i.id_categoria}>{i.nombre}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>                        
                            </Col>
                            <Col>
                                <Form.Group controlId="cantidad_sobre_guia">
                                    <Form.Label className="karanda-label">Cantidad</Form.Label>
                                    <Form.Control disabled={!edit} value={cantidad} onChange={(e) => { setCantidad(e.target.value); }} type="number" />
                                </Form.Group>
                            </Col>                            
                            <Col>
                                <Form.Group controlId="carimbo">
                                    <Form.Label className="karanda-label">Carimbo</Form.Label>
                                    <Form.Control disabled={!edit} value={carimbo} onChange={(e) => { setCarimbo(e.target.value); }} type="number" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="pesoTotal">
                                    <Form.Label className="karanda-label">Peso total</Form.Label>
                                    <NumericFormat
                                        disabled={!edit}
                                        className="karanda-input"
                                        value={pesoTotal}
                                        customInput={Form.Control}
                                        thousandSeparator="."
                                        decimalSeparator="," 
                                        decimalScale={2}
                                        allowNegative={false}
                                        onValueChange={(v) => setPesoTotal(v.floatValue)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="observacion">
                                    <Form.Label className="karanda-label">Observación</Form.Label>
                                    <Form.Control disabled={!edit} value={observacion} onChange={(e) => {setObservacion(e.target.value); }} type="text" />
                                </Form.Group>
                            </Col>
                        </Row>
                        {
                            edit ? (<></>) : (
                                <>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="creador">
                                                <Form.Label className="karanda-label">Creador</Form.Label>
                                                <Form.Control value={userCreation} disabled type="email" />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="modificador">
                                                <Form.Label className="karanda-label">Modificador</Form.Label>
                                                <Form.Control value={userLastModification} disabled type="email" />
                                            </Form.Group>                                
                                        </Col>                     
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="creacion">
                                                <Form.Label className="karanda-label">Creación</Form.Label>
                                                <Form.Control value={creationDate} disabled type="date-time" />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>                                    
                            )
                        }
                    </Form>                    
                </Modal.Body>
                <Modal.Footer>
                    {
                        edit 
                        ? (<Button variant="primary" onClick={handleUpdate}>Actualizar</Button>)
                        : (<></>)
                    }
                    <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );

};

export default NacimientoView;